import NotificationPopupItemHandler from './NotificationPopupItemHandler';
import attributes from '../../../Constants/js/attributes';
import Keys from '../../../Constants/js/Keys';

const NotificationPopup = (function () {

    const activeClass = 'notification-popup--active';
    const notificationButtonId = 'notificationsButton';
    const closeButton = '.notification-popup__close';

    var _notificationCounter = document.querySelector('#notificationsButton span');
    var _popupContainer = document.querySelector('.notification-popup__container');

    var _popupItemHander;
    var _items = [];

    function init(popupItemHander) {

        _popupItemHander = popupItemHander ?? NotificationPopupItemHandler;
        if(!_popupItemHander.render) throw new Error('Popup Item Handler is missing render() method');

        _items = [];

        updateCounter();

        document.querySelector(`#${notificationButtonId}`).addEventListener(attributes.events.click, e => {
            _popupContainer.classList.toggle(activeClass);
            e.preventDefault();
        });

        _popupContainer.querySelector(`${closeButton}`).addEventListener(attributes.events.click, e => {
            _popupContainer.classList.toggle(activeClass);
            e.preventDefault();
        });

        window.addEventListener(attributes.events.keyup, e => {
            if(e.keyCode === Keys.codes.esc) 
            {
                _popupContainer.classList.remove(activeClass);
            } 
        });
        
        //setup global click handler to hide component when click is outside of it
        window.addEventListener(attributes.events.click, e => {
            let parent = e.target;
            for(let i = 0; i < 5; i ++)
            {
                if(!parent) continue; 

                if(parent.classList && 
                    (parent.classList.contains('notification-popup__item') || 
                    parent.classList.contains('notification-popup') ||
                    parent.id === notificationButtonId)) 
                {
                    return;
                }

                parent = parent.parentElement;
            }

            _popupContainer.classList.remove(activeClass);
        });
    }

    function updateCounter(){
        const count = _items.filter(x => x.active === true).length;
        setCount(count);
    }

    function setCount(total) {
        _notificationCounter.innerText = total;
        if(total === 0) {
            _notificationCounter.classList.add(attributes.css.class.displayNone);
        }else{
            _notificationCounter.classList.remove(attributes.css.class.displayNone);
        }
    }

    function addItem(item) {
        _popupItemHander.render(item);
        _items.push(item);
    }

    function clearItems(){
        _popupItemHander.clear();
        _items = [];

        updateCounter();
    }

    return {
        init: init,
        addItem: addItem,
        clearItems: clearItems,
        setCount: setCount
    };

})();

export default NotificationPopup;